<template>
  <div>

    <div class="row mt-4">
      <div class="col-md-8">
        <input class="input form-control"
               @keypress.enter="find()"
               v-model="query.generic"
               placeholder="Pesquisar por título ou descrição">
        <search-icon @click="find()" class="icon icon-within"/>
      </div>

      <button class="col-md-1 ml-2 btn-sm btn-outline"
              :class="{ 'btn-outline-active': showFilter }"
              @click="showFilter = !showFilter">
        Filtros
      </button>

      <a v-if="hasFilter" @click="clearQueryAndFind()" href="#" class="nowrap">remover filtros</a>
    </div>

    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-4">
          <label>Contas</label>
          <Select2 v-if="filterAccounts.length > 0" :options="filterAccounts" v-model="query.accountId"/>
          <input v-else disabled class="form-control" value="Carregando contas...">
        </div>

        <div class="col-md-4">
          <label>Usuários</label>
          <Select2 v-if="filterUsers.length > 0" :options="filterUsers" v-model="query.userId"/>
          <input v-else disabled class="form-control" value="Carregando emails...">
        </div>

        <div class="col-md-4">
          <label for="calendar-type">Tipo</label>
          <Select2 id="calendar-type" :options="filterTypes" v-model="query.type"/>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-4">
          <label for="start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="start-date" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="calendar-period-type">Tipo de período</label>
          <select v-model="query.periodType" id="calendar-period-type" class="form-control">
            <option value="">Criado em</option>
            <option value="updated_at">Atualizado em</option>
            <option value="start_date">Começa em</option>
            <option value="end_date">Termina em</option>
          </select>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-12 mt-4 pt-2 text-right">
          <button @click="clearQueryAndFind()" class="btn btn-sm btn-outline mr-2">Limpar filtros</button>
          <button @click="find()" class="btn btn-sm btn-primary">Aplicar</button>
        </div>
      </div>
    </template>
    <hr>

    <div class="row">
      <div class="col-sm-12">

        <div class="row mt-4">
          <div class="col-md-12">
            <strong>
              {{infoTotalModels}}
            </strong>
          </div>
        </div>

        <table class="table table-borderless table-align table-h51">
          <thead>
          <tr>
            <th class="nowrap">ID</th>
            <th class="nowrap">Conta</th>
            <th class="nowrap">Criado por</th>
            <th class="nowrap">User ID's</th>
            <th class="nowrap">Tipo</th>
            <th class="nowrap">Título</th>
            <th class="nowrap">Cor</th>
            <th class="nowrap">Começa em</th>
            <th class="nowrap">Finaliza em</th>
            <th class="nowrap">Criado em</th>
            <th class="nowrap">Atualizado em</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="calendar in calendars" :key="calendar.id">
            <td>{{ calendar.id }}</td>
            <td>{{ buildAccount(calendar) }}</td>
            <td>{{ buildUser(calendar) }}</td>
            <td>{{ calendar.userIds }}</td>
            <td>{{ calendar.type | t }}</td>
            <td :title="calendar.description">{{ calendar.title }}</td>
            <td :style="{ color: calendar.color }">{{ calendar.color }}</td>
            <td>{{ calendar.startDate | datetime }}</td>
            <td>{{ calendar.endDate | datetime }}</td>
            <td>{{ calendar.createdAt | datetime }}</td>
            <td>{{ calendar.updatedAt | datetime }}</td>
          </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import ModelMapper from '@/mixins/ModelMapper'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import Select2 from '@/components/shares/Select2'
  import { SearchIcon } from 'vue-feather-icons'
  
  export default {
    components: { Pagination, SearchIcon, Select2 },
    computed: {
      calendars() {
        return this.models
      }
    },
    created() {
      this.buildFilter()
      this.addOrderBy('createdAt')
      this.includes.push('account', 'user')
      this.$set(this.query, 'periodType', '')

      this.defaultModelSetting.updateQueryURL = true
      this.asyncTemplateSelect({
        byURL: true,
        pagination: true
      })
    },
    data() {
      return {
        filterAccounts: [],
        filterTypes: [
          { label: 'Privado', value: 'private' },
          { label: 'Público', value: 'public' },
          { label: 'Global', value: 'goblal' },
        ],
        filterUsers: [],
        modelPathPrefix: 'admin',
        nameModel: 'Calendar',
        showFilter: false,
      }
    },
    methods: {
      buildAccount(observer) {
        if (observer.account)
          return observer.account.name
        else
          return observer.accountId
      },
      buildFilter() {
        this.axios.get('/admin/events/filter_options')
          .then(response => {
            this.filterUsers = response.data.users.map(e => ({ label: e.email, value: e.id }))
            this.filterAccounts = response.data.accounts.map(a => ({ label: `${a.id} - ${a.name}`, value: a.id }))
          })
      },
      buildUser(observer) {
        if (observer.user)
          return observer.user.email
        else
          return observer.userId
      },
      find() {
        this.asyncTemplateSelect()
      }
    },
    mixins: [ModelMapper],
    name: 'Calendar'
  }
</script>

<style scoped>

</style>